/**
 * Created by Administrador on 11/11/2016.
 */
(function(){
    'use strict';

    var numberMin = {
        template: '',
        controller: numberMinController,
        controllerAs: 'vm',
        require: {
            model: "ngModel"
        },
        bindings: {
            min: '=',
            errorKey: "@",
            formName: '<'
        }
    };

    angular
        .module('completeAir')
        .component('numberMin', numberMin);

    function numberMinController(){
        var vm = this;

        vm.$onInit = function () {
            vm.ngModelCtrl = vm.formName;
        }

        vm.$postLink = function() {
            var minValidator = function (value) {
                var valueMin = vm.min || 0;
                if (value) {
                    value = value.replace(/[^0-9]/g, '');
                }
                if (!isEmpty(value) && value < valueMin) {
                    vm.ngModelCtrl.$setValidity(vm.errorKey, false);
                    return undefined;
                } else {
                    vm.ngModelCtrl.$setValidity(vm.errorKey, true);
                    return value;
                }
            };

            vm.ngModelCtrl.$parsers.push(minValidator);
            vm.ngModelCtrl.$formatters.push(minValidator);
        }
    }

})();
